import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=93375054&"
import script from "./Quiz.vue?vue&type=script&lang=ts&"
export * from "./Quiz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports